export function buildQueryString(params) {
  const queryParts = []

  for (const [key, value] of Object.entries(params)) {
    if (Array.isArray(value)) {
      for (const item of value) {
        queryParts.push(`${key}[]=${encodeURIComponent(item)}`)
      }
    } else {
      queryParts.push(`${key}=${encodeURIComponent(value)}`)
    }
  }

  return queryParts.join('&')
}

export function currentHost() {
  return window.location.protocol + '//' + window.location.host
}

export function currentURL() {
  return window.location.href
}

export function getUrlSubdomain() {
  const blacklist = [
    'dev',
    'qa',
    'stg',
    'prd',
    'tst'
  ]
  const subdomain = window.location.host.split('.')[0]
  return blacklist.includes(subdomain) ? '' : subdomain
}
